/* FP V3 — Discount badges injector
   Scans product cards, PDP, and cart drawer for sale prices (compare_at_price > price)
   and injects:
     - "-XX%" corner badge on collection cards
     - "-XX%" badge on PDP gallery + "Save €X (-Y%)" callout next to price
     - "Save €X" pill per cart drawer line + total savings recap
*/
(function() {
  'use strict';

  function parseAmount(text) {
    if (!text) return null;
    var m = String(text).replace(/\s/g, '').replace(/[^\d.,]/g, '');
    if (!m) return null;
    // Heuristic: if comma present and dot, dot is thousands → strip
    if (m.indexOf(',') !== -1 && m.indexOf('.') !== -1) {
      m = m.replace(/\./g, '').replace(',', '.');
    } else if (m.indexOf(',') !== -1) {
      // comma only → likely decimal sep (EUR style)
      m = m.replace(',', '.');
    }
    var v = parseFloat(m);
    return isNaN(v) ? null : v;
  }

  function pickSym(text) {
    if (!text) return '';
    var m = String(text).match(/[€$£¥₣kr]|CA\$|A\$|NZ\$|MX\$|CHF|Ft|zł|Kč|lei|лв/);
    return m ? m[0] : '';
  }

  function fmtMoney(value, sample) {
    var sym = pickSym(sample) || '€';
    var rounded = (value % 1 === 0) ? value.toFixed(0) : value.toFixed(2);
    // Mimic the sample's punctuation style
    if (sample && sample.indexOf(',') !== -1 && sample.indexOf('.') === -1) {
      rounded = rounded.replace('.', ',');
    }
    // Symbol before or after?
    if (sample && /\d.*[€£¥]|\d.*kr|\d.*CHF|\d.*Ft|\d.*zł|\d.*Kč|\d.*lei|\d.*лв/.test(sample)) {
      return rounded + ' ' + sym;
    }
    return sym + rounded;
  }

  // ─── COLLECTION CARDS ────────────────────────────────────────
  // Horizon markup (from blocks/_product-card-gallery.liquid + snippets/price.liquid):
  //   - badge: .product-badges__badge (text = locale "Sale")
  //   - struck old price: .compare-at-price
  //   - sale (new) price: .price-item--sale (visible inside .price__sale)
  function processCard(card) {
    if (!card || card.dataset.fpBadgeDone) return;
    var regEl = card.querySelector('.compare-at-price, .price__sale .price-item--regular');
    var saleEl = card.querySelector('.price__sale .price-item--sale, .price-item--sale.price');
    if (!regEl || !saleEl) return;

    var reg = parseAmount(regEl.textContent);
    var sale = parseAmount(saleEl.textContent);
    if (!reg || !sale || sale >= reg) return;

    var pct = Math.round((1 - sale / reg) * 100);
    if (pct < 5) return;

    // Replace native badge text with "-XX%" (keeps Horizon's positioning + color scheme)
    var nativeBadge = card.querySelector('.product-badges__badge, .price__badge-sale, .badge.price__badge-sale, .product-card__badge--sale');
    if (nativeBadge && !nativeBadge.dataset.fpReplaced) {
      nativeBadge.textContent = '-' + pct + '%';
      nativeBadge.dataset.fpReplaced = '1';
    }
    // No fallback corner badge — Horizon already provides .product-badges__badge for sale items
    card.dataset.fpBadgeDone = '1';
  }

  // ─── REPLACE ALL NATIVE "Sale" BADGES (PDP gallery, anywhere) ────────
  function replaceNativeSaleBadges() {
    var badges = document.querySelectorAll('.product-badges__badge:not([data-fp-replaced]), .price__badge-sale:not([data-fp-replaced]), .badge.price__badge-sale:not([data-fp-replaced])');
    badges.forEach(function(badge) {
      // Skip "Sold out" badges — keep the original text
      var text = (badge.textContent || '').trim().toLowerCase();
      if (/sold ?out|épuisé|epuise|agotado|ausverkauft|esaurito/.test(text)) return;

      // Find nearest price scope to compute the % (card OR product-information)
      var scope = badge.closest('.product-card, .product-information, .product-grid li, [class*="product"]') || badge.parentElement;
      if (!scope) return;
      var regEl = scope.querySelector('.compare-at-price, .price__sale .price-item--regular');
      var saleEl = scope.querySelector('.price__sale .price-item--sale, .price-item--sale.price');
      if (!regEl || !saleEl) return;
      var reg = parseAmount(regEl.textContent);
      var sale = parseAmount(saleEl.textContent);
      if (!reg || !sale || sale >= reg) return;
      var pct = Math.round((1 - sale / reg) * 100);
      if (pct < 5) return;
      badge.textContent = '-' + pct + '%';
      badge.dataset.fpReplaced = '1';
    });
  }

  function scanCards() {
    document.querySelectorAll('.product-card').forEach(processCard);
  }

  // ─── PDP ─────────────────────────────────────────────────────
  function processPDP() {
    var pi = document.querySelector('.product-information');
    if (!pi) {
      // Not a PDP — clear any stale gallery badges
      document.querySelectorAll('.fp-pdp-discount-badge').forEach(function(b){ b.remove(); });
      document.querySelectorAll('.fp-savings').forEach(function(s){ s.remove(); });
      return;
    }

    var regEl = pi.querySelector('.compare-at-price, .price__sale .price-item--regular');
    var saleEl = pi.querySelector('.price__sale .price-item--sale, .price__sale .price-item--last, .price-item--sale');

    // If no sale on currently selected variant → clean up badges
    if (!regEl || !saleEl) {
      document.querySelectorAll('.fp-pdp-discount-badge').forEach(function(b){ b.remove(); });
      document.querySelectorAll('.fp-savings').forEach(function(s){ s.remove(); });
      return;
    }

    var reg = parseAmount(regEl.textContent);
    var sale = parseAmount(saleEl.textContent);
    if (!reg || !sale || sale >= reg) return;

    var pct = Math.round((1 - sale / reg) * 100);
    var saving = reg - sale;
    if (pct < 5) return;

    // 1) Gallery corner badge — idempotent: update existing or create new
    var gallery = document.querySelector('.product-media-gallery, .product-media-container, .product-media');
    if (gallery) {
      var existingBadge = gallery.querySelector('.fp-pdp-discount-badge');
      if (existingBadge) {
        // Update text in case % changed (variant switch)
        existingBadge.textContent = '-' + pct + '%';
      } else {
        var b = document.createElement('div');
        b.className = 'fp-pdp-discount-badge';
        b.textContent = '-' + pct + '%';
        gallery.style.position = gallery.style.position || 'relative';
        gallery.appendChild(b);
      }
    }

    // 2) Savings callout next to price — idempotent
    var priceWrap = pi.querySelector('.price--on-sale, .price__container, .price');
    if (priceWrap) {
      var existingPill = priceWrap.parentElement.querySelector('.fp-savings');
      var pillText = 'Save ' + fmtMoney(saving, saleEl.textContent) + ' (-' + pct + '%)';
      if (existingPill) {
        existingPill.textContent = pillText;
      } else {
        var pill = document.createElement('span');
        pill.className = 'fp-savings';
        pill.textContent = pillText;
        priceWrap.insertAdjacentElement('afterend', pill);
      }
    }
  }

  // ─── CART DRAWER ─────────────────────────────────────────────
  async function processCartDrawer() {
    var dlg = document.querySelector('cart-drawer-component dialog');
    if (!dlg) return;

    // Pull cart for accurate per-line savings
    var cart;
    try { cart = await fetch('/cart.js').then(function(r){return r.json();}); } catch(e) { return; }
    if (!cart || !cart.items) return;

    var totalSavings = 0;
    var sym = '';
    cart.items.forEach(function(item) {
      if (!item.original_line_price || item.original_line_price <= item.line_price) return;
      // line_price is in cents (Shopify Markets converts at display time)
      // Per-line savings = (original_line_price - line_price)
      var savedCents = (item.original_price - item.price) * item.quantity;
      if (savedCents <= 0) return;

      // Find the line element
      var lineEl = dlg.querySelector('cart-items-component [data-line-key="' + item.key + '"]') ||
                   dlg.querySelector('[data-line-key="' + item.key + '"]') ||
                   dlg.querySelector('[data-variant-id="' + item.variant_id + '"]');
      if (!lineEl) return;

      // Avoid double-injection
      if (lineEl.querySelector('.fp-cart-line-savings')) return;

      // Find a price holder in this line to read currency formatting
      var priceHolder = lineEl.querySelector('.price-item, .cart-item__price, [class*="price"]');
      var sample = priceHolder ? priceHolder.textContent.trim() : '€';
      sym = pickSym(sample) || sym || '€';

      var savedAmount = savedCents / 100;
      var pct = Math.round((1 - item.price / item.original_price) * 100);
      var pill = document.createElement('div');
      pill.className = 'fp-cart-line-savings';
      pill.textContent = 'Save ' + fmtMoney(savedAmount, sample) + ' (-' + pct + '%)';
      // Append after price area
      var titleArea = lineEl.querySelector('.cart-item__details, .cart-item__info, .cart-item__title');
      (titleArea || lineEl).appendChild(pill);

      totalSavings += savedAmount;
    });

    // Total recap above checkout
    var existingTotal = dlg.querySelector('.fp-cart-total-savings');
    if (existingTotal) existingTotal.remove();
    if (totalSavings > 0) {
      var summary = dlg.querySelector('.cart-drawer__summary, [class*="summary"]');
      if (summary) {
        var recap = document.createElement('div');
        recap.className = 'fp-cart-total-savings';
        recap.innerHTML = '<span>You save</span><span>' + fmtMoney(totalSavings, sym || '€') + '</span>';
        summary.insertAdjacentElement('beforebegin', recap);
      }
    }
  }

  // ─── COLLECTION SWATCHES → LINK to variant PDP (instead of buggy in-card swap) ───
  // Intercept click on a swatch inside results-list and navigate to the variant URL.
  document.addEventListener('click', function(ev) {
    var swatchEl = ev.target.closest('results-list .swatch, results-list label.swatch, results-list swatches-variant-picker-component label, results-list swatches-variant-picker-component input[type="radio"], product-recommendations .swatch, product-recommendations label.swatch, product-recommendations swatches-variant-picker-component label, product-recommendations swatches-variant-picker-component input[type="radio"]');
    if (!swatchEl) return;

    // Find the parent <swatches-variant-picker-component> for the product URL
    var picker = swatchEl.closest('swatches-variant-picker-component');
    if (!picker) return;
    var productUrl = picker.dataset.productUrl || picker.getAttribute('data-product-url') || '';
    if (!productUrl) {
      // Fallback: locate the card's primary link
      var card = swatchEl.closest('.product-card');
      var link = card && card.querySelector('a[href*="/products/"]');
      if (link) productUrl = link.getAttribute('href');
    }
    if (!productUrl) return;

    // Get the variant ID from the input value
    var input = swatchEl.tagName === 'INPUT' ? swatchEl : swatchEl.querySelector('input[type="radio"]');
    var variantId = input ? input.value : null;

    ev.preventDefault();
    ev.stopPropagation();

    // Build URL with ?variant=...
    var url = productUrl.split('?')[0];
    if (variantId) {
      url += (url.indexOf('?') === -1 ? '?' : '&') + 'variant=' + variantId;
    }
    window.location.href = url;
  }, true);

  // ─── INIT ────────────────────────────────────────────────────
  function init() {
    scanCards();
    replaceNativeSaleBadges();
    processPDP();
    processCartDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-scan on dynamic updates: filter, pagination, variant change, cart open
  var mo = new MutationObserver(function(muts) {
    var shouldRescan = false;
    var shouldPDP = false;
    var shouldCart = false;
    for (var i = 0; i < muts.length; i++) {
      var m = muts[i];
      for (var j = 0; j < m.addedNodes.length; j++) {
        var n = m.addedNodes[j];
        if (n.nodeType !== 1 || n.tagName === 'FONT') continue; // 30/09 : ignore les <font> de l'auto-traduction
        if (n.classList && n.classList.contains('product-card')) shouldRescan = true;
        else if (n.querySelector && n.querySelector('.product-card')) shouldRescan = true;
        if (n.querySelector && n.querySelector('.product-information')) shouldPDP = true;
        if (n.tagName === 'CART-DRAWER-COMPONENT' || (n.querySelector && n.querySelector('cart-drawer-component'))) shouldCart = true;
        if (n.classList && (n.classList.contains('cart-item') || n.classList.contains('cart-items-component'))) shouldCart = true;
      }
    }
    if (shouldRescan) scanCards();
    if (shouldPDP) processPDP();
    if (shouldCart) setTimeout(processCartDrawer, 80);
    // Always re-scan native badges (cheap, idempotent via data-fp-replaced)
    if (shouldRescan || shouldPDP) replaceNativeSaleBadges();
  });
  mo.observe(document.body, { childList: true, subtree: true });

  // Refresh on cart updates
  document.addEventListener('cart:updated', function() { setTimeout(processCartDrawer, 200); });
  document.addEventListener('cart:refresh', function() { setTimeout(processCartDrawer, 200); });
  document.addEventListener('on:cart:add', function() { setTimeout(processCartDrawer, 250); });

  // Re-process PDP on variant change — listen to ALL variant change events Horizon may fire
  ['variant:change', 'on:variant:change', 'product:variant-change',
   'product:section:rendered', 'shopify:variant:changed'].forEach(function(name) {
    document.addEventListener(name, function() { setTimeout(processPDP, 80); });
  });

  // Watch the variant-picker inputs directly (radio change) — most reliable trigger
  document.addEventListener('change', function(e) {
    if (e.target && e.target.closest('.product-information variant-picker, .product-information .variant-picker, .product-information [class*="variant"]')) {
      setTimeout(processPDP, 60);
      setTimeout(processPDP, 250);
      setTimeout(processPDP, 600);
    }
  });

  // Dedicated observer on the gallery container — re-injects badge on any DOM change
  function watchGallery() {
    var gallery = document.querySelector('.product-media-gallery, .product-media-container');
    if (!gallery || gallery.dataset.fpWatched) return;
    gallery.dataset.fpWatched = '1';
    var galleryMo = new MutationObserver(function() { setTimeout(processPDP, 50); });
    galleryMo.observe(gallery, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchGallery);
  } else {
    watchGallery();
  }
  // Re-watch if the gallery itself is replaced
  setInterval(watchGallery, 2000);
})();
